import React from "react";
import "../css/FooterDetail.css";

function Footer() {
  return (
    <div className="footerDetail jumbotron-fluid">
      <p className="copyright text-center">
        Copyright © 2020 WeSpace | All Right Reserved
      </p>
    </div>
  );
}

export default Footer;
